import LocalizedStrings from 'localized-strings';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    confirm: 'Confirmer mon export',
    errorMessage:
      'An error has occurred. Please try again and if the problem persists, please contact us.',
    title: 'Nouvel export comptable',
  },
  fr: {
    confirm: 'Confirmer mon export',
    errorMessage:
      'An error has occurred. Please try again and if the problem persists, please contact us.',
    title: 'Nouvel export comptable',
  },
} as const);

export default locales;
